import { useFeatureFlagContext } from 'utils/hooks/context/useFeatureFlagContext'

export const useDesktopView = (toggleKey: string) => {
  const { getFeatureByKey } = useFeatureFlagContext()

  return getFeatureByKey(toggleKey)
}
